import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Lightweight GA4 loader (set REACT_APP_GA_MEASUREMENT_ID in env to enable)
const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
if (gaId) {
  const existing = document.querySelector('script[data-ga-loader="true"]');
  if (!existing) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    s.dataset.gaLoader = 'true';
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);} // eslint-disable-line
    gtag('js', new Date());
    gtag('config', gaId);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
